<template>
  <div class="home">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-s-home"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>在线订票</el-breadcrumb-item>
        <el-breadcrumb-item>填写信息</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="public-w time-choose display-flex">
      <div class="time-box">
        游玩时段
        <div class="time-select">{{ timeStr }}</div>
      </div>
      <div class="ticket-num">
        余票<span>{{ ticketNumber }}</span>
      </div>
    </div>
    <div class="public-w ticket-list">
      <div
        class="ticket-item"
        v-for="(ticketItem, ticketIndex) in ticketInfoNew.tickets"
        :key="ticketIndex"
      >
        <div class="ticket-title display-flex">
          <div class="ticket-name">
            <div class="title">
              {{ ticketItem.name
              }}<span v-if="ticketItem.is_show_price"
                >¥{{ ticketItem.price }} </span
              ><span v-if="allContanctInfo[ticketItem.code]"
                >*{{ allContanctInfo[ticketItem.code].length }}</span
              >
            </div>
            <div class="details">
              {{ getCouponTicketName(ticketItem.coupon_tickets) }}
              <span>{{ getCouponTicketPrice(ticketItem.coupon_tickets) }}</span>
            </div>
          </div>
          <div class="add-list display-flex">
            <div
              class="preferential"
              v-if="showTicketWarning(ticketItem)"
              @click="showTicketWarningHandler(ticketItem)"
            >
              查看优惠条件>>
            </div>
            <div
              class="frequent-contacts"
              @click="contanctListShow(ticketIndex)"
            >
              <i class="el-icon-s-order"></i><br />常用联系人
            </div>
            <div class="add-user" @click="addPassage(ticketIndex)">
              <i class="el-icon-user-solid"></i><br />新增游客
            </div>
          </div>
        </div>
        <div class="user-list">
          <el-row
            :gutter="10"
            class="user-item"
            v-for="(ticketUser, ticketIndex) in allContanctInfo[
              ticketItem.code
            ]"
            :key="ticketIndex"
          >
            <el-col :span="5"
              >入园人<span>{{ ticketUser.user_name }}</span></el-col
            >
            <el-col :span="8"
              >{{ IDTypeName(ticketUser.id_type)
              }}<span>{{ ticketUser.id_number }}</span></el-col
            >
            <el-col :span="5"
              >游客类型<span>{{ ticketUser.custom_type }}</span></el-col
            >
            <!-- <el-col :span="5">优惠类型<span>退役军人</span></el-col>-->
            <el-col
              style="float: right"
              :span="1"
              @click.native="deleteTicket(ticketUser)"
              ><i class="el-icon-close"></i
            ></el-col>
          </el-row>
          <add-user
            v-if="currentIndex == ticketIndex"
            :ticket="ticketDetailBack"
            :currentDate="currentDate"
            :startTime="startTime"
            :endTime="endTime"
            v-on:childUser="hideAddUser"
          ></add-user>
        </div>
      </div>
    </div>
    <div class="public-w submit-orders display-flex">
      <div class="fl">
        <el-checkbox v-model="instructionsChecked" @change="instructionChange">
          我已阅读并同意</el-checkbox
        >
        <a target="_blank" @click="ticketsNoteShow">《预订须知》</a>
      </div>
      <div class="fr display-flex">
        <div class="total">
          合计:<span>¥{{ totalPrice }}</span>
        </div>
        <div class="submit">
          <el-button
            type="primary"
            size="medium"
            round
            class="btn"
            @click="toSubmit"
            >提交订单</el-button
          >
        </div>
      </div>
    </div>
    <!-- 优惠条件弹框 -->
    <el-dialog
      title="提示"
      :visible.sync="preferentialTerms"
      :show-close="false"
      width="30%"
    >
      <div class="preferential-terms">
        {{ preferentialText }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="preferentialTermsFn">取 消</el-button>
        <el-button type="primary" @click="preferentialTermsFn">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 预定须知 -->
    <el-dialog
      title="购票须知"
      :visible.sync="ticketNotesShow"
      :show-close="false"
      width="45%"
    >
      <div class="preferential-terms" v-html="ticketsNotes"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ticketNotesCancel">取 消</el-button>
        <el-button type="primary" @click="ticketNotesCancel">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 常用联系人弹框 -->
    <el-dialog
      title="从常用联系人添加游客"
      :visible.sync="frequentContacts"
      :show-close="false"
      width="40%"
    >
      <div class="frequent-contacts">
        <div class="contact-list">
          <el-row
            :gutter="10"
            class="contact-item"
            v-for="(item, index) in contactsList"
            :key="index"
          >
            <el-col :span="2">
              <el-checkbox
                v-model="item.checked"
                fill="#010101"
                @change="contanctSelect($event, index)"
              ></el-checkbox>
            </el-col>
            <el-col :span="4">{{ item.username }}</el-col>
            <el-col :span="6">{{
              item.contact_type == 0 ? '成人' : '儿童'
            }}</el-col>
            <el-col :span="12">{{
              filterIDNumber(item.id_type, item.id_number)
            }}</el-col>
          </el-row>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button cancelButtonClass="cancel" @click="contanctAddCancel"
          >取 消</el-button
        >
        <el-button
          type="primary"
          confirmButtonClass="confirm"
          @click="done"
          data-names="确定"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 选择优惠类型弹框 -->
    <el-dialog
      title="选择优惠类型"
      :visible.sync="preferentialType"
      :show-close="false"
      :close-on-click-modal="false"
      width="30%"
    >
      <div class="preferential-terms">
        {{ contanctPreferentialText }}
      </div>
      <el-radio-group
        class="preferentialType"
        v-model="preferentialTypeRadio"
        v-for="(pItem, pIndex) in preferentialList"
        :key="pIndex"
        @change="preChange(pIndex)"
      >
        <el-radio :label="pIndex">{{ pItem }}</el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button cancelButtonClass="cancel" @click="preferentialTypeCancel"
          >取 消</el-button
        >
        <el-button
          type="primary"
          confirmButtonClass="confirm"
          @click="preferentialTypeConfirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import AddUser from '../../components/AddUser.vue';
import user from '../../api/user';
import order from '../../api/order';
import moment from 'moment';
import routerTo from '@/router/routerTo';
import {
  isArray,
  convertEnter,
  IDNumberFilter,
  UUID,
  convertDateFromString,
} from '../../setup/common';
import constValuesConfig from '../../setup/constantConfig';
export default {
  components: {
    AddUser,
  },
  data() {
    return {
      timeStr: '',
      startTime: '',
      endTime: '',
      orderDate: '', //传值到订单详情 2020-09-01 12时-15时格式
      currentDate: '',
      ticketNumber: '',
      palceCode: '',
      ticketsNotes: '', //购票须知
      ticketNotesShow: false, //是否展示购票须知
      ticketInfoNew: {}, //门票数组
      preferentialText: '', //优惠条件
      contanctPreferentialText: '', //联系人选择优惠条件展示
      preferentialList: '', //优惠类型选择
      contactTypeName: '', //优惠类型name
      instructionsChecked: false, //预定须知
      preferentialTerms: false, //优惠条件弹框
      frequentContacts: false, //常用联系人弹框
      ticketDetailBack: {}, //传值到user
      contanctTicketDatail: {}, //传值联系人做处理优惠类型
      isAddUserShow: false, //是否显示添加游客
      currentIndex: -1, //当前门票的index
      certificateTypeList: constValuesConfig.ID,
      contactsList: [], //联系人列表
      selectedContact: [], //选择的联系人列表
      currentContanctIndex: -1,
      preferentialType: false, //常用联系人优惠类型弹框
      preferentialTypeRadio: -1, //常用联系人优惠类型弹框radio选择
    };
  },
  computed: {
    ticketInfo: function() {
      return this.$store.getters.ticketInfo;
    },
    allContanctInfo: function() {
      return this.$store.getters.allContanctInfo;
    },
    totalPrice: function() {
      return this.$store.getters.totalPrice;
    },
    allSubmitTickets: function() {
      return this.$store.getters.allSubmitTickets;
    },
  },
  created() {
    let query = this.$route.query;
    let startTime = query.startTime;
    let endTime = query.endTime;
    this.orderStartTime = query.startTime;
    this.orderEndTime = query.endTime;
    this.palceCode = query.palceCode;
    this.ticketNumber = query.ticketCount;
    this.ticketsNotes = query.ticketsNotes;
    this.currentDate = query.currentDate;
    this.timeStr = startTime + '-' + endTime;
    let timeStartStr = convertDateFromString(
      this.currentDate + ' ' + startTime,
    );
    let timeEndStr = convertDateFromString(this.currentDate + ' ' + endTime);
    let orderStartTime = moment(timeStartStr).format('HH时');
    let orderEndTime = moment(timeEndStr).format('HH时');
    this.orderDate =
      this.currentDate + ' ' + orderStartTime + '-' + orderEndTime;
    this.startTime = moment(timeStartStr).format('YYYYMMDDHHmm');
    this.endTime = moment(timeEndStr).format('YYYYMMDDHHmm');
    this.getTicketListInfo();
    this.getContactList();
  },
  methods: {
    async getTicketListInfo() {
      await this.$store.dispatch('getTicketConfigInfo', {
        presale_date: this.currentDate,
        marketing_code: process.env.VUE_APP_MERCHANT_CODE,
      });
      if (
        Object.prototype.hasOwnProperty.call(this.ticketInfo, this.palceCode)
      ) {
        this.ticketInfoNew = this.ticketInfo[this.palceCode];
      }
    },
    hideAddUser() {
      this.currentIndex = -1;
    },
    addPassage(index) {
      //添加游客点击
      this.ticketDetailBack = this.ticketInfoNew.tickets[index];
      this.currentIndex = index;
    },
    contanctListShow(index) {
      //常用联系人点击
      this.preferentialList = [];
      this.contactsList.forEach((contactItem) => {
        this.$set(contactItem, 'checked', false);
      });
      this.contanctTicketDatail = this.ticketInfoNew.tickets[index];
      this.frequentContacts = true;
      if (
        this.contanctTicketDatail.description &&
        typeof this.contanctTicketDatail.description != 'undefined' &&
        this.contanctTicketDatail.description.length > 0
      ) {
        this.contanctPreferentialText = this.contanctTicketDatail.description;
      }
      let preferentialListGet = JSON.parse(
        localStorage.getItem('customerType'),
      );
      for (const key in preferentialListGet) {
        if (
          preferentialListGet[key].ticket_type ==
          this.contanctTicketDatail.ticket_type
        ) {
          this.preferentialList = preferentialListGet[key].customer_type.split(
            ',',
          );
        }
      }
    },
    contanctSelect(e, index) {
      //联系人点击选择
      console.log('联系人选择', e, index);
      this.currentContanctIndex = index;
      if (this.contanctPreferentialText && this.preferentialList.length) {
        if (!e) {
          /*this.preferentialType = true;*/
          this.$set(this.contactsList[index], 'checked', false);
        } else {
          this.$set(this.contactsList[index], 'checked', true);
        }
        if (this.contactsList[index].checked) {
          this.preferentialType = true;
        }
      } /*else {
        if (e == true) {
          this.$set(this.contactsList[index], 'checked', true);
        } else {
          this.$set(this.contactsList[index], 'checked', false);
        }
      }*/
      this.selectedContact = this.contactsList;
    },
    preferentialTypeConfirm() {
      //优惠类型选择确认
      if (!this.contactTypeName) {
        alert('请选择游客类型');
        return;
      }
      this.selectedContact[
        this.currentContanctIndex
      ].contact_type = this.contactTypeName;
      this.contactTypeName = '';
      this.preferentialTypeRadio = -1;
      this.preferentialType = false;
      this.contactsList[this.currentContanctIndex].checked = true;
    },
    preferentialTypeCancel() {
      //优惠类型取消
      this.preferentialType = false;
      this.contactTypeName = '';
      this.preferentialTypeRadio = -1;
      this.contactsList[this.currentContanctIndex].checked = false;
    },
    ticketNotesCancel() {
      //购票须知取消和确定方法
      this.ticketNotesShow = false;
    },
    ticketsNoteShow() {
      this.ticketNotesShow = true;
    },
    contanctAddCancel() {
      this.frequentContacts = false;
    },
    done() {
      //联系人选择完毕
      let nowContactList = [];
      this.selectedContact.forEach((item) => {
        if (item.checked) {
          nowContactList.push(item);
        }
      });
      let newUsersArray = [];
      nowContactList.forEach((user) => {
        let newUser = {};
        if (this.contanctPreferentialText && this.preferentialList.length) {
          newUser.contact_type = this.contactTypeName;
          newUser.custom_type = user.contact_type;
        } else {
          if (parseInt(user.contact_type) == 0) {
            newUser.contact_type = '成人';
          } else if (parseInt(user.contact_type) == 1) {
            newUser.contact_type = '儿童';
          }
          newUser.custom_type = newUser.contact_type;
        }
        newUser.user_name = user.username;
        newUser.id_type = user.id_type;
        newUser.id_number = user.id_number;
        newUser.id = user.id;
        newUser.key = '' + user.id_number + '_' + UUID();
        newUser.phone = user.phone;
        newUser.gender = user.gender;
        newUser.ticketType = this.contanctTicketDatail.ticket_type;
        let newTicket = {};
        newTicket.ticket_type = this.contanctTicketDatail.code;
        newTicket.use_time = this.startTime;
        newTicket.use_end_time = this.endTime;
        newTicket.ticketName = this.contanctTicketDatail.name;
        newTicket.price = this.contanctTicketDatail.price;
        newTicket.ticket_type_id = this.contanctTicketDatail.ticket_type;
        newTicket.uid = UUID();
        if (this.contanctTicketDatail) {
          newTicket.description = this.contanctTicketDatail.description;
        }
        let tickets = [];
        tickets.push(newTicket);
        newUser.tickets = tickets;
        newUsersArray.push(newUser);
        this.$store.commit('updateContactInfo', newUsersArray);
        this.frequentContacts = false;
      });
    },
    toSubmit() {
      //提交订单
      if (!this.instructionsChecked) {
        alert('请阅读并同意相关规则');
        return;
      }
      if (this.allContanctInfo.ticketCount == 0) {
        alert('请添加游客信息!');
        return;
      }
      this.submitOrder();
    },
    makeTransaction() {
      let strDate = moment(new Date()).format('YYYYMMDDHHmm');
      let random = Math.floor(Math.random() * 10);
      return strDate + random;
    },
    async submitOrder() {
      await order.relateMerchant({
        // place_code: "S0028151",
        merchant_code: process.env.VUE_APP_MERCHANT_CODE, //TODO
      });
      const orderInfo = await order.orderSubmit({
        user_ticket_info: this.allSubmitTickets,
        transaction: this.makeTransaction(),
        product_id: process.env.VUE_APP_TICKET_PRODUCT_CODE, //TODO
        merchant_code: process.env.VUE_APP_MERCHANT_CODE, //商户数字账号
        marketing_code: process.env.VUE_APP_MERCHANT_CODE, //销售渠道编码
        marketing_name: '自营渠道', //销售渠道名称
      });
      console.log('订单详情是', orderInfo);
      routerTo.toOrderConfirm(this.$router, false, {
        orderId: orderInfo.order_id,
        orderDate: this.orderDate,
      });
      this.$store.commit('delecteContact', null);
    },
    preChange(e) {
      this.preferentialTypeRadio = e;
      this.contactTypeName = this.preferentialList[this.preferentialTypeRadio];
    },
    instructionChange(e) {
      //是否阅读同意
      this.instructionsChecked = e;
    },
    IDTypeName(idType) {
      let idName = '';
      this.certificateTypeList.forEach((item) => {
        if (item.value == idType) {
          idName = item.name;
        }
      });
      return idName;
    },
    filterIDNumber(id_type, idNumber) {
      return IDNumberFilter(id_type, idNumber);
    },
    //获取套票详情 格式:含全价门票+车票
    getCouponTicketName: function(couponTickets) {
      if (!isArray(couponTickets)) {
        return '';
      }
      let result = '';
      let names = [];
      for (var i = 0; i < couponTickets.length; i++) {
        let couponTicketInfo = couponTickets[i];
        names.push(couponTicketInfo.ticket_name);
      }
      result = names.join(' + ');
      if (names.length > 0) {
        result = '含' + result;
      }
      return result;
    },
    //获取套票价格内容 格式为:((¥125.00+¥85.00))
    getCouponTicketPrice: function(couponTickets) {
      if (!isArray(couponTickets)) {
        return '';
      }
      let result = '';
      let names = [];
      for (var i = 0; i < couponTickets.length; i++) {
        let couponTicketInfo = couponTickets[i];
        if (couponTicketInfo.is_show_price) {
          names.push('¥' + couponTicketInfo.ticket_price);
        }
      }
      result = names.join('+');
      if (names.length > 0) {
        result = '(' + result + ')';
      }
      return result;
    },
    //是否显示弹出优惠条件
    showTicketWarning: function(ticket) {
      if (
        ticket.description &&
        typeof ticket.description != 'undefined' &&
        ticket.description.length > 0
      ) {
        return true;
      }
      return false;
    },
    //弹出优惠条件
    showTicketWarningHandler(ticket) {
      if (
        ticket.description &&
        typeof ticket.description != 'undefined' &&
        ticket.description.length > 0
      ) {
        this.preferentialTerms = true;
        this.preferentialText = convertEnter(ticket.description);
      }
    },
    // 优惠条件弹框
    preferentialTermsFn() {
      this.preferentialTerms = !this.preferentialTerms;
    },
    async getContactList() {
      const contactListGet = await user.getContactList({});
      contactListGet.forEach((contactItem) => {
        this.$set(contactItem, 'checked', false);
      });
      this.contactsList = contactListGet;
    },
    // 常用联系人弹框
    frequentContactsFn(e, val) {
      // 点击确定的时候显示选择优惠类型弹框
      if (val) {
        this.preferentialType = !this.preferentialType;
      }
      this.frequentContacts = !this.frequentContacts;
    },
    //删除游客信息
    deleteTicket(contanctInfo) {
      this.$store.commit('delecteContact', contanctInfo);
    },
    // 常用联系人优惠类型弹框
    preferentialTypeFn() {
      this.preferentialType = !this.preferentialType;
    },
  },
};
</script>
<style scoped lang="less">
.time-choose {
  margin: 24px auto 16px auto;
  padding: 24px;
  color: #515457;
  font-size: 16px;
  .time-box {
    .time-select {
      display: inline-block;
      width: 200px;
      margin-left: 8px;
      border: 1px solid #dcdfe6;
      border-radius: 20px;
      color: #c0c4cc;
      font-size: 16px;
      line-height: 40px;
      text-align: center;
      background-color: #eee;
    }
  }
  .ticket-num {
    line-height: 40px;
    span {
      margin-left: 8px;
      color: #f15b4a;
      font-weight: bold;
      font-size: 20px;
    }
  }
}
.ticket-list {
  background-color: transparent;
  .ticket-item {
    margin-bottom: 16px;
    padding-bottom: 8px;
    border-radius: 8px;
    background-color: #fff;
    .ticket-title {
      .ticket-name {
        padding: 24px;
        text-align: left;
        .title {
          margin-bottom: 8px;
          color: #191b26;
          font-weight: bold;
          font-size: 20px;
          span {
            margin-left: 8px;
            color: #f15b49;
            font-size: 20px;
          }
        }
        .details {
          color: #515457;
          font-size: 14px;
          span {
            color: #f15b49;
          }
        }
      }
      .add-list {
        color: #31a775;
        .preferential {
          margin: 42px 24px 42px 0;
          font-size: 14px;
          cursor: pointer;
        }
        .frequent-contacts,
        .add-user {
          width: 145px;
          padding: 24px 0;
          border-left: 1px dashed #eee;
          color: #31a775;
          font-weight: bold;
          font-size: 16px;
          text-align: center;
          cursor: pointer;
          i {
            margin-bottom: 8px;
            font-size: 24px;
          }
        }
      }
    }
    .user-list {
      padding: 0 24px;
      .user-item {
        margin-bottom: 8px;
        border-top: 1px solid #eee;
        border-bottom: 1px solid #eee;
        line-height: 52px;
        .el-col {
          box-sizing: border-box;
          margin-right: 10px;
          padding: 0;
          border-right: 1px solid #eee;
          color: #191b26;
          font-weight: bold;
          font-size: 16px;
          text-align: left;
          span {
            margin-left: 16px;
            color: #31a775;
          }
        }
        .el-col:last-child {
          margin: 0;
          border: 0;
          text-align: right;
          i {
            color: #f15b49;
            font-weight: bold;
            font-size: 20px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
.submit-orders {
  margin-bottom: 24px;
  padding: 24px;
  line-height: 36px;
  .fl {
    color: #515457;
    font-size: 16px;
    /deep/.el-checkbox__label {
      font-size: 16px;
    }
    /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
      color: #515457;
    }
    a {
      color: #31a775;
      font-size: 16px;
    }
  }
  .fr {
    .total {
      margin-right: 62px;
      color: #191b26;
      font-size: 16px;
      span {
        margin-left: 8px;
        color: #f15b49;
        font-weight: bold;
        font-size: 24px;
      }
    }
    .btn {
      border-color: #31a775;
      background-color: #31a775;
      box-shadow: 0 2px 8px 0 rgba(2, 190, 110, 0.2);
    }
  }
}
.preferential-terms {
  color: #515457;
  font-size: 16px;
  line-height: 32px;
  text-align: left;
}
.frequent-contacts {
  .contact-list {
    .contact-item {
      color: #515457;
      font-weight: 400;
      font-size: 16px;
      line-height: 32px;
      text-align: left;
    }
  }
}
/deep/.el-checkbox__inner {
  width: 24px;
  height: 24px;
  &:after {
    height: 14px;
    left: 8px;
  }
  &:hover {
    border-color: #31a775;
  }
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #31a775;
  background-color: #31a775;
}
.dialog-footer {
  /deep/.el-button--primary {
    border-color: #31a775;
    background-color: #31a775;
  }
  /deep/.el-button--default:hover {
    border-color: #83a899;
    color: #31a775;
    background-color: #f2f8f6;
  }
}
.preferentialType {
  width: 100%;
  margin-top: 16px;
  font-size: 16px;
  text-align: left;
  /deep/.el-radio__input.is-checked .el-radio__inner {
    border-color: #31a775;
    background: #31a775;
  }
  /deep/.el-radio__input.is-checked + .el-radio__label {
    color: #31a775;
  }
  /deep/.el-radio__label {
    font-size: 16px;
  }
}
</style>
